import DPA, { connect } from 'servisofts-page';
import { Parent } from '.';
import { SNavigation, SPopup, SText } from 'servisofts-component';
import Model from '../../../Model';
import SSocket from 'servisofts-socket'
class index extends DPA.edit {
    constructor(props) {
        super(props, {
            Parent: Parent,
            excludes: ["key", "fecha_on", "key_usuario", "estado", "key_restaurante", "url","params"]
        });
    }
    $allowAccess() {
        return Model.usuarioPage.Action.getPermiso({ url: Parent.path, permiso: "edit" })
    }
    $getData() {
        return Parent.model.Action.getByKey(this.pk);
    }
    $inputs() {
        var inp = super.$inputs();
        // inp["params"]
        // inp.busqueda = {
        //     label: "Busqueda",
        //     type: "text",
        //     required: false,
        // }

        if (inp["tiempo"]?.defaultValue) {
            let tiempoMili = inp["tiempo"]?.defaultValue;
            inp["tiempo"].defaultValue = tiempoMili / 1000; // Convertir a segundos
        }

        // delete inp["params"];
        return inp;
    }

    $onSubmit(data) {

        // if (data.busqueda) {
        //     data.url = "/buscar"
        //     data.params = { "busqueda": data.busqueda }
        // }else{
        //     data.url = ""
        //     data.params = {}
        // }
        if (data.tiempo) {
            data.tiempo = data.tiempo * 1000; // Convertir a milisegundos
        }

        Parent.model.Action.editar({
            data: {
                ...this.data,
                ...data
            },
            key_usuario: ""
        }).then((resp) => {
            SNavigation.goBack();
        }).catch(e => {
            console.error(e);
        })
    }
}

export default connect(index);